import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type RevokeSeamVisionlineEndpointRequest = {
  clientId: string
}

export type RevokeSeamVisionlineEndpointResponse = {
  endpointId: string
  revoked: boolean
  endpointDeleted: boolean
}

const revokeSeamVisionlineEndpoint = async (data: RevokeSeamVisionlineEndpointRequest) => {
  const response = await authAPI.delete<RevokeSeamVisionlineEndpointResponse>(
    `/seam-visionline/users/${data.clientId}/endpoint`,
  )
  return response.data
}

export const useRevokeSeamVisionlineEndpoint = () =>
  useMutation({ mutationFn: revokeSeamVisionlineEndpoint })
